import { render, staticRenderFns } from "./CatchDialog.vue?vue&type=template&id=28bb3ed9&scoped=true"
import script from "./CatchDialog.vue?vue&type=script&lang=js"
export * from "./CatchDialog.vue?vue&type=script&lang=js"
import style0 from "./CatchDialog.vue?vue&type=style&index=0&id=28bb3ed9&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28bb3ed9",
  null
  
)

export default component.exports